exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".W6jC9ujhXfczmdLQ3mReI h1,.W6jC9ujhXfczmdLQ3mReI h2,.W6jC9ujhXfczmdLQ3mReI h3{margin-top:20px;margin-bottom:10px}.W6jC9ujhXfczmdLQ3mReI h4,.W6jC9ujhXfczmdLQ3mReI h5,.W6jC9ujhXfczmdLQ3mReI h6{margin-top:10px;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"bootstrapHeading": "W6jC9ujhXfczmdLQ3mReI"
};